export default {
	list: 'Partner',
	grid: {		
		gridId:'partnerGrid',
		checkbox: true,
		edit: true,
		delete: true,		
		height: 300,
		pageSize: 100,
		groupable: true,
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly:false
		},
		PartnerID: {
			class: 'value',
			dataName: 'PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 100,
			hidden: false,
			readOnly:false
		},
		Prefix: {
			class: 'value',
			dataName: 'Prefix',
			type: 'string',
			title: 'Prefix',
			width: 100,
			hidden: true,
			readOnly:false
		},
		FirstName: {
			class: 'value',
			dataName: 'FirstName',
			type: 'string',
			title: 'First Name',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MiddleName: {
			class: 'value',
			dataName: 'MiddleName',
			type: 'string',
			title: 'Middle Name',
			width: 100,
			hidden: true,
			readOnly:false
		},
		LastName: {
			class: 'value',
			dataName: 'LastName',
			type: 'string',
			title: 'Last Name',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Suffix: {
			class: 'value',
			dataName: 'Suffix',
			type: 'string',
			title: 'Suffix',
			width: 100,
			hidden: true,
			readOnly:false
		},
		EntityName: {
			class: 'value',
			dataName: 'EntityName',
			type: 'string',
			title: 'Entity Name',
			width: 100,
			hidden: true,
			readOnly:false
		},
		FullName: {
			class: 'value',
			dataName: 'FullName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: false,
			readOnly:false
		},
		TaxId: {
			class: 'value',
			dataName: 'TaxId',
			type: 'string',
			title: 'Tax Id',
			width: 100,
			hidden: false,
			readOnly:false
		},
		TSDocId: {
			class: 'value',
			dataName: 'TSDocId',
			type: 'string',
			title: 'TS Document Id',
			width: 100,
			hidden: false,
			readOnly:false
		},
		Domestic: {
			class: 'choice',
			dataName: 'Domestic',
			type: 'string',
			title: 'Domestic',
			width: 100,
			hidden: false,
			readOnly:false
		},
		PartnerStatus: {
			class: 'choice',
			dataName: 'PartnerStatus',
			type: 'string',
			title: 'Partner Status',
			width: 100,
			hidden: false,
			readOnly:false
		},
		DocumentDeliveryMethod : {
			class: 'choice',
			dataName: 'DocumentDeliveryMethod ',
			type: 'string',
			title: 'DocumentDeliveryMethod ',
			width: 100,
			hidden: true,
			readOnly:false
		},
		ReceiveFMV: {
			class: 'choice',
			dataName: 'ReceiveFMV',
			type: 'string',
			title: 'Receive FMV',
			width: 100,
			hidden: true,
			readOnly:false
		},
		HireDate: {
			class: 'value',
			dataName: 'HireDate',
			type: 'date',
			title: 'Hire Date',
			width: 100,
			hidden: true,
			readOnly:false
		},
		LeaveDate: {
			class: 'value',
			dataName: 'LeaveDate',
			type: 'date',
			title: 'Leave Date',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Position:{
			class: 'choice',
			dataName: 'Position',
			type: 'string',
			title: 'Position',
			width: 100,
			hidden: false,
			readOnly:false
		},
		MemoGroup:{
			class: 'choice',
			dataName: 'MemoGroup',
			type: 'string',
			title: 'Memo Group',
			width: 100,
			hidden: false,
			readOnly:false
		},
		VestingAcceleration:{
			class: 'choice',
			dataName: 'VestingAcceleration',
			type: 'string',
			title: 'Vesting Acceleration',
			width: 100,
			hidden: true,
			readOnly:false
		},
		BoughtOut:{
			class: 'choice',
			dataName: 'BoughtOut',
			type: 'string',
			title: 'BoughtOut',
			width: 100,
			hidden: true,
			readOnly:false
		},
		EMail: {
			class: 'value',
			dataName: 'EMail',
			type: 'string',
			title: 'EMail',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Address1: {
			class: 'value',
			dataName: 'Address1',
			type: 'string',
			title: 'Address1',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Address2: {
			class: 'value',
			dataName: 'Address2',
			type: 'string',
			title: 'Address2',
			width: 100,
			hidden: true,
			readOnly:false
		},
		City: {
			class: 'value',
			dataName: 'City',
			type: 'string',
			title: 'City',
			width: 100,
			hidden: true,
			readOnly:false
		},
		State: {
			class: 'value',
			dataName: 'State',
			type: 'string',
			title: 'State',
			width: 100,
			hidden: true,
			readOnly:false
		},
		PostalCode: {
			class: 'value',
			dataName: 'PostalCode',
			type: 'string',
			title: 'Postal Code',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Country: {
			class: 'value',
			dataName: 'Country',
			type: 'string',
			title: 'Country',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MailAddress1: {
			class: 'value',
			dataName: 'MailAddress1',
			type: 'string',
			title: 'Mail Address1',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MailAddress2: {
			class: 'value',
			dataName: 'MailAddress2',
			type: 'string',
			title: 'Mail Address2',
			width: 100,
			hidden: true,
			readOnly:false,
		},
		MailCity: {
			class: 'value',
			dataName: 'MailCity',
			type: 'string',
			title: 'Mail City',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MailState: {
			class: 'value',
			dataName: 'MailState',
			type: 'string',
			title: 'Mail State',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MailPostalCode: {
			class: 'value',
			dataName: 'MailPostalCode',
			type: 'string',
			title: 'Mail Postal Code',
			width: 100,
			hidden: true,
			readOnly:false
		},
		MailCountry: {
			class: 'value',
			dataName: 'MailCountry',
			type: 'string',
			title: 'Mail Country',
			width: 100,
			hidden: true,
			readOnly:false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true,
			readOnly:false
		},
		StartBuyout: {
			class: 'value',
			dataName: 'StartBuyout',
			type: 'string',
			title: 'Buyout started',
			width: 100,
			hidden: true,
			readOnly:false
		},
		StartRetire:{
			class: 'value',
			dataName: 'StartRetire',
			type: 'string',
			title: 'Retirement started',
			width: 100,
			hidden: true,
			readOnly:false
		}
	}
}